{
  "title": "شرائح العمولة",
  "add": "إضافة شريحة",
  "noLimit": "بلا حد",
  "created": "تم إنشاء الشريحة بنجاح",
  "updated": "تم تحديث الشريحة بنجاح",
  "deleted": "تم حذف الشريحة بنجاح",
  "statusChanged": "تم تغيير حالة الشريحة بنجاح",
  "columns": {
    "name": "الاسم",
    "from": "من",
    "to": "إلى",
    "commission": "العمولة",
    "status": "الحالة"
  },
  "rowActions": {
    "trigger": "إجراءات {{name}}"
  },
  "statusConfirmTitle": "تغيير حالة {{name}}",
  "deleteConfirmTitle": "تأكيد الحذف",
  "deleteConfirmDescription": "سيتم حذف الشريحة \"{{name}}\" نهائيا.",
  "drawer": {
    "createTitle": "إضافة شريحة",
    "createDescription": "أدخل بيانات الشريحة الجديدة.",
    "editTitle": "تعديل الشريحة",
    "editDescription": "تعديل بيانات الشريحة.",
    "fields": {
      "name": "الاسم",
      "noLimit": "بلا حد",
      "upperLimit": "الحد الأعلى",
      "commission": "العمولة"
    }
  },
  "filters": {
    "allStatuses": "كل الحالات"
  },
  "gaps": {
    "rangeMessage": "لا توجد شريحة فعالة للمبالغ من {{from}} إلى {{to}}",
    "aboveMessage": "لا توجد شريحة فعالة للمبالغ من {{from}} فما فوق"
  },
  "validation": {
    "tooManyDecimals": "يسمح بخمس منازل عشرية كحد أقصى."
  }
}
